// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PowershellIcon = createSvgIcon(
  <svg width={24} height={19} fill="none" viewBox="0 0 24 19">
    <path
      fill="currentColor"
      d="M20.28 0c.5 0 .81.4.7.91l-3.2 13.98c-.12.5-.61.91-1.11.91H.72c-.5 0-.81-.4-.7-.9l3.2-14c.12-.5.61-.9 1.11-.9zm-7.33 8.18c.22-.35.2-.8-.08-1.09L7.98 1.9a.9.9 0 0 0-1.28-.01c-.38.36-.4.93-.08 1.28l4.09 4.34v.1l-6.5 4.7c-.4.28-.47.85-.17 1.27s.87.52 1.26.23l7.2-5.17q.38-.25.45-.45m-2.44 3.85a.8.8 0 0 0-.82.8c0 .45.37.81.82.81h3.88c.45 0 .81-.35.82-.8s-.37-.81-.82-.81z"
    />
  </svg>,
  "Powershell",
);
export default PowershellIcon;
